import { Stack } from '@fukuri-admins/ui/common';
import { useCallback } from 'react';
import { components, type OptionProps } from 'react-select';
import styles from './styles.module.scss';
import type { OptionType } from './type';

export const Option = (props: OptionProps<OptionType>) => {
  const { subLabel } = props.data;

  const handleRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (props.isFocused && element) {
        element.scrollIntoView({
          block: 'nearest',
          behavior: 'smooth',
        });
      }
    },
    [props.isFocused]
  );

  return (
    <div ref={handleRef}>
      <components.Option {...props}>
        {subLabel ? (
          <Stack direction='column' gap={2}>
            <span>{props.children}</span>
            <span className={styles.optionSubLabel}>{subLabel}</span>
          </Stack>
        ) : (
          props.children
        )}
      </components.Option>
    </div>
  );
};
